import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { LiveAudioVisualizer } from "react-audio-visualize";
import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
// import { useDispatch } from "react-redux";
import {
  DeleteOutlined,
  PauseOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import { Button, Tooltip } from "antd";
// import { SendMessHorizontalBlueIcon } from "assets/icons";
// import httpRequest from "services/httpRequest";
// import { doCompleteMediaContent } from "stores/slices/mediaContent";
// import { addMessage, doSendMessage } from "stores/slices/message";
// import { v4 as uuidv4 } from "uuid";

const AudioRecord = forwardRef(function AudioRecord(props, ref) {
  const {
    // conversationSelected,
    // setIsShowSendMessage,
    // isAudioRecording,
    // setIsAudioRecording,
    // handleLockConversation,
    isStartAudioRecording,
    setIsStartAudioRecording,
    setAudioFile,
    isShowDiscardRecord = false,
  } = props;

  const recorderControls = useAudioRecorder();
  // const dispatch = useDispatch();
  const [isPauseRecorded, setIsPauseRecorded] = useState(false);
  const [isSaveAudio, setIsSaveAudio] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);

  // const [isRecordSuccess, setIsRecordSuccess] = useState(false);
  // const [urlRecord, setUrlRecord] = useState(null);

  const handleAudioRecord = blob => {
    if (blob !== undefined) {
      let newFile = new File([blob], uuid() + ".mp3", {
        type: "audio/mp3",
      });
      let fileInfo = {
        id: uuid(),
        name: newFile.name,
        file: newFile,
        url: URL.createObjectURL(newFile),
        type: newFile.type.startsWith("audio") ? "audio" : "file",
      };
      setAudioFile(fileInfo);
    }
  };

  // const handleSendAudioMessage = async fileAudio => {
  //   return;
  //   // eslint-disable-next-line no-unreachable
  //   if (fileAudio) {
  //     const messageRequest = {
  //       type: "MEDIA",
  //       conversationId: conversationSelected.id,
  //       externalId: uuidv4().replace(/-/g, ""),
  //     };

  //     const { payload } = await dispatch(doSendMessage(messageRequest));
  //     if (payload && payload.status === 200) {
  //       const newMessage = {
  //         conversationId: messageRequest.conversationId,
  //         id: messageRequest.externalId,
  //         messageDirection: "OUT",
  //         messageDataType: "MEDIA",
  //         mediaContents: [
  //           {
  //             id: fileAudio.id,
  //             filename: fileAudio.name,
  //             location: fileAudio.url,
  //             type: fileAudio.type && fileAudio.type.toUpperCase(),
  //           },
  //         ],
  //       };
  //       handleUpload(fileAudio, newMessage);
  //     }
  //   }
  // };

  // const handleUpload = async (fileAudio, message) => {
  //   return;
  //   // eslint-disable-next-line no-unreachable
  //   try {
  //     const formData = new FormData();
  //     formData.append("file", fileAudio.file);
  //     const request = {
  //       cannedAccessControlList: "PublicRead",
  //       conversationId: conversationSelected.id,
  //       messageId: message.id,
  //       file: fileAudio.file,
  //     };
  //     const response = await httpRequest({
  //       url: `/api/media-content`,
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //       params: {
  //         cannedAccessControlList: request.cannedAccessControlList,
  //         conversationId: request.conversationId,
  //         messageId: request.messageId,
  //       },
  //       data: formData,
  //     });
  //     if (response && response.status === 200) {
  //       await dispatch(doCompleteMediaContent(message.id));
  //       await dispatch(addMessage(message));
  //       await setIsShowSendMessage(false);
  //       await setIsAudioRecording(false);
  //       await handleLockConversation(conversationSelected, false);
  //     }
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // };

  function formatRecordingTime(recordingTime) {
    const minutes = Math.floor(recordingTime / 60);
    const seconds = recordingTime % 60;
    const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
    return formattedTime;
  }

  useEffect(() => {
    if (isStartAudioRecording) {
      recorderControls.startRecording();
    }
  }, [isStartAudioRecording]);

  useEffect(() => {
    if (recorderControls && recorderControls.recordingTime) {
      setRecordingTime(recorderControls?.recordingTime);
    }
  }, [recorderControls?.recordingTime]);

  useImperativeHandle(ref, () => ({
    handleRecordingComplete: () => {
      recorderControls.stopRecording();
      setIsSaveAudio(true);
    },
    handleDiscardRecord: () => {
      recorderControls.stopRecording();
    },
  }));

  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {isShowDiscardRecord && (
          <Tooltip title="Discard voice message">
            <Button
              type="text"
              shape="circle"
              onClick={() => {
                recorderControls.stopRecording();
                setIsStartAudioRecording(false);
              }}
              icon={<DeleteOutlined />}
              style={{ marginRight: 8 }}
            />
          </Tooltip>
        )}

        <div
          style={{
            display: "none",
          }}
        >
          <AudioRecorder
            audioTrackConstraints={{
              noiseSuppression: true,
              echoCancellation: true,
            }}
            recorderControls={recorderControls}
            downloadFileExtension="mp3"
            showVisualizer={true}
            onRecordingComplete={blob => {
              if (
                recorderControls &&
                !recorderControls.isRecording &&
                isSaveAudio
              ) {
                handleAudioRecord(blob);
              }
            }}
          />
        </div>

        {recorderControls.mediaRecorder && (
          <LiveAudioVisualizer
            mediaRecorder={recorderControls.mediaRecorder}
            width={100}
            height={30}
            barWidth={4}
            gap={2}
            barColor={"lightblue"}
          />
        )}

        {recordingTime > 0 && (
          <span style={{ marginLeft: 8 }}>
            {formatRecordingTime(recordingTime)}
          </span>
        )}

        <Tooltip title="Pause recording">
          <Button
            type="text"
            shape="circle"
            onClick={() => {
              recorderControls.togglePauseResume();
              setIsPauseRecorded(!isPauseRecorded);
            }}
            icon={!isPauseRecorded ? <PauseOutlined /> : <PlayCircleOutlined />}
            style={{ marginLeft: 8 }}
          />
        </Tooltip>
      </div>
    </div>
  );
});

export default AudioRecord;
